import React from 'react';
export function Footer() {
  return <footer className="bg-white py-8 border-t border-dark-border/10 text-center px-4" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <p className="text-dark/60 text-sm" data-id="element-125">
          © {new Date().getFullYear()} Mega Pack Educación Ambiental y
          Sostenibilidad en el Aula — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}